// Push-Server akzeptiert nur absolute URLs. AD-Links koennen laut pathType
// relativ zur Kino-Website sein (siehe NewsletterSectionAds) und muessen
// vor dem Autofill gegen die Frontpage-URL aufgeloest werden.
export const ABSOLUTE_URL_PATTERN = /^https?:\/\//i

const resolveAdLinkUrl = (link, baseUrl) => {
    const url = link?.url ? `${link.url}`.trim() : ''

    if(!url) {
        return ''
    }

    if('absolute' === link.pathType || ABSOLUTE_URL_PATTERN.test(url)) {
        return url
    }

    const base = baseUrl ? `${baseUrl}`.trim() : ''

    if(!base) {
        return ''
    }

    const baseWithSlash = '/' === base[base.length - 1] ? base : `${base}/`
    const relUrl = '/' === url[0] ? url.substring(1) : url

    return `${baseWithSlash}${relUrl}`
}

export default resolveAdLinkUrl
